module.exports = __webpack_public_path__ + "assets/zatca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zatca.png
// module id = 1202
// module chunks = 7